import {computed, ref} from 'vue';

const POPUP_NAME = 'applicationPopup';

export const useMultiPopupWindowStateHook = () => {
  const windows = new Map<string, Window>();
  const isOpened = ref<Map<string, boolean>>(new Map());
  const currentUrl = ref<Map<string, string>>(new Map());

  const getWindow = computed(() => (key: string) => windows.get(key));
  const getIsOpened = computed(
    () => (key: string) => isOpened.value.get(key) ?? false,
  );
  const getCurrentUrl = computed(
    () => (key: string) => currentUrl.value.get(key) ?? '',
  );

  const openUrl = (key: string, url: string) => {
    const existingWindow = windows.get(key);
    if (existingWindow && !existingWindow.closed) {
      existingWindow.location.href = url;
      existingWindow.focus();
    } else {
      const newWindow = window.open(
        url,
        key,
        'width=1200,height=800,left=100,top=100,menubar=no,toolbar=yes,location=yes,scrollbars=yes,resizable=yes',
      );
      if (newWindow) {
        windows.set(key, newWindow);
        isOpened.value.set(key, true);
      }
    }
    currentUrl.value.set(key, url);
  };

  const openDefault = (url: string) => openUrl(POPUP_NAME, url);

  const close = (key: string) => {
    windows.get(key)?.close();
    windows.delete(key);
    isOpened.value.delete(key);
    currentUrl.value.delete(key);
  };

  const closeAll = () => {
    windows.forEach((w) => w.close());
    windows.clear();
    isOpened.value.clear();
    currentUrl.value.clear();
  };

  const focus = (key: string) => {
    windows.get(key)?.focus();
  };

  const focusDefault = () => focus(POPUP_NAME);

  setInterval(() => {
    windows.forEach((w, key) => {
      if (w.closed) {
        windows.delete(key);
        isOpened.value.delete(key);
      }
    });
  }, 1000);

  return {
    getWindow,
    getIsOpened,
    getCurrentUrl,
    openUrl,
    openDefault,
    close,
    closeAll,
    focus,
    focusDefault,
  };
};

export const multiPopupWindowState = useMultiPopupWindowStateHook();
